exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".childList[data-v-4f33e1fa]{width:20%;padding:5px 0;position:relative;display:block;text-align:center;border-bottom:1px solid #e0e0e0;background:#f9f9f9}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4f33e1fa&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/product/Cate.vue
// module id = 589
// module chunks = 2